import React from 'react';
import { BsArrowUpRight } from 'react-icons/bs'
import { motion } from 'framer-motion';
import { fadeIn } from '../../variants';

const services = [
    {
        name: 'Front-End',
        description: "I can Create a Successful Website That Is Fast And Easy To Use",
        link: "Learn more"
    }
]

const Services = () => {
    return (
        <section className='section pt-[180px] md:pt-4' id='services'>

            <div className='container mx-auto'>
                <div className='flex flex-col lg:flex-row'>
                {/* text & image*/}
                    <motion.div
                    variants={fadeIn('right',0.3)}
                    initial='hidden'
                    whileInView={'show'}
                    viewport={{once:false ,amount:0.3}}
                    className='flex-1 lg:bg-services lg:bg-bottom bg-no-repeat mix-blend-lighten mb-12 lg:mb-0'>
                        <h2 className='h2 text-accent mb-6'>What I Do.</h2>
                        <h3 className='h3 max-w-[455px] mb-16'>
                            I'm a Freelance Front-End Developer with 1 year of Experience.
                        </h3>
                        <button className='btn btn-sm'><a href="https://github.com/Yasser-Mohamed">See more</a></button>
                    </motion.div>
                    {/* services */}
                    <motion.div
                    variants={fadeIn('left',0.5)}
                    initial='hidden'
                    whileInView={'show'}
                    viewport={{once:false ,amount:0.3}}
                    className='flex-1'>
                        <div>
                        {services.map((serv , index)=>{
                            const {name ,description,link}= serv
                            return (
                                <div key={index}>
                                    <div className='max-w-[476px]'>
                                        <h4 className=' tracking-wider font-primary font-semibold text-[20px] mb-6'>{name}</h4>
                                        <p className='font-secondary leading-tight'>{description}</p>
                                    </div>
                                    <div className='flex flex-col flex-1 items-end'>
                                        <a href="https://github.com/Yasser-Mohamed?tab=repositories" className='btn w-9 h-9 mb-[42px] flex justify-center items-center'><BsArrowUpRight /></a>
                                        <a href="https://github.com/Yasser-Mohamed?tab=repositories" className='text-gradient text-sm'>{link}</a>
                                    </div>
                                </div>
                            )
                        })}
                        </div>
                        
                    </motion.div>
                </div>
            </div>
        </section>
    );
}

export default Services;
